
import Vue from "vue";
import HomeNews from "@/components/HomeNews.vue";
import HomeAbout from "@/components/HomeAbout.vue";
import { heroCarouselMixin } from "@/utils/heroCarousel";

export default Vue.extend({
  components: { HomeNews, HomeAbout },
  name: "Home",
  mixins: [heroCarouselMixin],
});
